module.exports = __webpack_public_path__ + "static/img/manual-17.2316450.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-17.png
// module id = 69m0
// module chunks = 4